import { IAppState } from '../../../AppModulesWrapper';

export const selectAutoProlongTooltipText = (state: IAppState): string => {
  return state.servicePickerWidget.checkoutInfo.autoProlongInfo.tooltipText;
};
